import {Injectable} from '@angular/core';
import {UploadDocumentsService} from '../../../../+my-libraries/+sites/document-library/shared/services/upload-documents.service';
import {API_URLS} from '../../../../../../environments/env-routes';
import {APIHelper} from '../../../../../../shared/services/api-helper/api-helper.service';
import {Room} from '../../models/room.class';
import { promise } from 'protractor';

interface IRoom {
  salleName: string;
  equipments?: string;
  description?: string;
  isVirtual: boolean;
  picture?: string;
  allowedParticipants: number;
}

@Injectable({
  providedIn: 'root'
})
export class RoomService {
  constructor(
    private api: APIHelper,
    private uploadService: UploadDocumentsService
  ) {}

  uploadProfileImage(file: File): Promise<any> {
    if (!file) {
      return new Promise(res => res(false));
    }

    return this.getImagesPathNodeId()
      .then((parentId: string) => {
        const base_url =
          this.api.url + API_URLS.nodes.children.replace(':nodeId', parentId);
        const params = '?autoRename=true&include=allowableOperations';
        const url = base_url + params;

        const parameters = {
          relativePath: '',
          renditions: 'doclib',
          include: 'allowableOperations',
          autoRename: true,
          nodeType: 'cm:content'
        };

        return this.uploadService.uploadBinary({
          file,
          method: 'POST',
          url,
          parameters
        });
      })
      .then((res: any) => {
      
        return res.body.entry.id;
      });
  }

  public addRoom(data: IRoom): Promise<Room> {
    return this.api
      .requestApi({
        action: API_URLS.rooms.create,
        method: 'POST',
        datas: data
      })
      .then(res => {
        return new Room(res);
      });
  }

  public deleteRoom(id: number): Promise<boolean> {
return new Promise((resolve, reject) => {
  this.api.requestApi({action:API_URLS.events.getAll}).then((res)=>{
if(res.filter(item => item.salle == id).length>0){
 reject(false);
}else{
  return this.api
  .requestApi({
    action: API_URLS.rooms.delete.replace(':salleid', '' + id),
    method: 'DELETE'
  })
  .then(res => {
    resolve(true);
    return true; 
  }).catch(error => {
    return false;});

}

  })
});




  }

  public editRoom(data: IRoom, id: number): Promise<Room> {
    return this.api
      .requestApi({
        action: API_URLS.rooms.edit.replace(':salleid', '' + id),
        method: 'PUT',
        datas: data
      })
      .then(res => {
        return new Room(res);
      });
  }

  public loadRooms(): Promise<Room[]> {
    return this.api.requestApi({ action: API_URLS.rooms.getAll }).then(res => {
      const rooms: Room[] = res.map(el => new Room(el));

      return rooms;
    });
  }

  public loadOneRoom(id: number): Promise<Room> {
    return this.api
      .requestApi({ action: API_URLS.rooms.get.replace(':salleid', id + '') })
      .then(res => {
        return new Room(res);
      });
  }

  public getTodayEvents(room: Room) {
    return this.api
      .requestApi({
        action: API_URLS.rooms.getTodayEvents.replace(':salleId', room.id + '')
      })
      .then(res => {
        return res;
      });
  }

  private getImagesPathNodeId(): Promise<string> {
    return this.api
      .requestApi({ action: API_URLS.rooms.getParentNodeId })
      .then((res: any) => {
        return res.parentId;
      });
  }
}
